import { fetcher } from '#lib/backendFetcher';

/**
 * Search companies and contacts across all accessible lead lists by name,
 * website/domain and phone number.
 * @param {Object} options
 * @param {string} options.q - Search term (min 2 characters)
 * @param {number} [options.limit=10] - Max hits per entity type
 * @returns {Promise<{companies: Array<Object>, contacts: Array<Object>}>}
 */
export const searchLeads = async ({ q, limit = 10 }) => {
	const params = new URLSearchParams({ q, limit });
	return fetcher(`/api/v1/leads/search?${params}`);
};

/**
 * Resolve the rank and page of a company within a prospect query under the
 * given sort, so the lead table can jump directly to its row.
 * @param {Object} options
 * @param {string} options.queryId - UUID of the prospect query
 * @param {string} options.companyId - companyId of the hit
 * @param {string} options.orderBy - Sort key (same vocabulary as the companies list)
 * @param {string} options.orderDir - Sort direction (asc|desc)
 * @param {number} options.pageSize - Page size the lead table renders with
 * @returns {Promise<{rank: number, page: number, total: number}>}
 */
export const getCompanyPosition = async ({ queryId, companyId, orderBy, orderDir, pageSize }) => {
	const params = new URLSearchParams({ orderBy, orderDir, pageSize });
	return fetcher(`/api/v1/leads/queries/${queryId}/companies/${companyId}/position?${params}`);
};
